<script>

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'
import LoadingScreen from '@/components/General/LoadingScreen'
import CheckboxToggle from '@/components/General/CheckboxToggle'
import Alert from '@/components/General/Alert'

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
	// Your options go here
});

import UserCircle from '@/ui/UserCircle'

//store
import { useSelectedItemStore } from "@/stores/selectedItem";

import PhotoEdit from '@/components/Core/Photos/PhotoEdit.vue'
import PhotoDelete from '@/components/Core/Photos/PhotoDelete.vue'
import PhotosDeleteBulk from '@/components/Core/Photos/PhotosDeleteBulk.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getPhotos, unlockPhoto, changeStatePhoto, rotatePhoto } from '@/services/servicePhoto';
import { getGalleryOptions } from '@/services/serviceGallery';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'Photos',
	mixins: [MixinGeneralFunct],
	components: {
		PhotoEdit
		, PhotoDelete
		, PhotosDeleteBulk
		, UserCircle
		, MyPagination
		, MyCountRecords
		, LoadingScreen
		, CheckboxToggle
		, Alert
	},
	props: ["auth", "secData", "params"],
	data() {
		return {
			metaData: [],

			isLoading: true,

			totalCount: 0,
			dataList: [],
			selectedFilterText: '',

			selectedGallery: '',
			optionsGalleries: [],

			selectedPhotoId: '',




			selectedPage: 1,
			selectedRecords: 10,
			selectedCol: 'a.id',
			selectedSort: 'desc',

			checkAllItems: false,



			showFilter: false,
			filterExtended: true,

			showedHelpbox: false,

			modalDelete: {},
			modalDeleteId: '',

			modalEdit: {},
			modalEditId: '',

			modalDeleteBulk: {},
			modalDeleteBulkId: '',


		}
	},

	mounted: function () {
		this.modalDeleteId = `modalPhoto${this.getRandomInt(999999999)}`;
		this.modalEditId = `modalPhoto${this.getRandomInt(999999999)}`;
		this.modalDeleteBulkId = `modalPhoto${this.getRandomInt(999999999)}`;
	},

	methods: {

		//na fontende aj preview aj tabula, zober povodne idcka a idcka po aktualizacii a tie naviac zobraz na par sekund inou farbou, alebo ako nove.

		//default data


		onLoadPage: function () {

			//show loader
			this.isLoading = true

			getPhotos({ filterText: this.selectedFilterText, filterGallery: this.selectedGallery, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords }).then(response => {
				console.log(response)
				if (!response.statusText) {
					this.isLoading = false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;

					//oznacenie poloziek cez strankovac
					for (let i = 0; i < this.dataList.length; i++) {
						if (this.allSelectedItems.indexOf(this.dataList[i].id) >= 0) {
							this.dataList[i].selectedId = true;
						}
					}
				} else {
					this.isLoading = false
					this.errorStatus = `${response.statusText} ${response.status}`
				}
			});

			getGalleryOptions().then(response => {
				this.optionsGalleries = response.optionsGalleries;
			});


		},


		//odomknutie zaznamu
		onUnLock: function (photoId) {
			this.cSession();
			this.isLoading = true
			unlockPhoto({ photoId }).then(response => {
				console.log(response)
				if (!response.statusText) {
					this.isLoading = false
					if (response.resCode == 1) {
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					} else if (response.resCode == 0) {
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					} else if (response.resCode == 2) {
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					} else if (response.resCode == 3) {
						this.toast.error(this.$t('msgCore.accessDenied'));
					}

				} else {
					this.isLoading = false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},




		//(od)oznacenie vsetkych poloziek
		onCheckAllItems: function () {
			if (this.checkAllItems) {
				for (let i = 0; i < this.dataList.length; i++) {
					this.dataList[i].selectedId = true;
					if (this.allSelectedItems.indexOf(this.dataList[i].id) == -1) {
						this.selectedItemStore.addSelectedItems(this.dataList[i].id);
					}
				}
			} else {
				for (let i = 0; i < this.dataList.length; i++) {
					this.dataList[i].selectedId = false;
					var indexToRemove = this.allSelectedItems.indexOf(this.dataList[i].id);
					if (indexToRemove >= 0) {
						this.selectedItemStore.deleteSelectedItems(indexToRemove);
					}
				}
			}
		},

		//oznacenie jednej polozky
		onCheckItem: function (index, id) {
			if (this.dataList[index].selectedId == true) {
				this.selectedItemStore.addSelectedItems(id);
			} else {
				var indexToRemove = this.allSelectedItems.indexOf(id);
				this.selectedItemStore.deleteSelectedItems(indexToRemove);
			}
		},

		//zrusenie vyberu
		onResetSelected: function () {
			for (let i = this.allSelectedItems.length; i >= 0; i--) {
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if (indexToRemove >= 0) {
					var index = this.dataList.findIndex(item => item.id == this.allSelectedItems[i]);
					if (index >= 0) {
						this.dataList[index].selectedId = false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
		},

		//radenie zoznamu - orders by
		orderByCol: function (col) {

			if (col === this.selectedCol) {
				this.selectedSort = this.selectedSort === 'asc' ? 'desc' : 'asc';
			}
			this.selectedCol = col;

			this.onLoadPage();
		},



		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if (this.selectedCol === col && this.selectedSort === 'asc') {
				return true;
			}
		},
		isDesc: function (col) {
			if (this.selectedCol === col && this.selectedSort === 'desc') {
				return true;
			}
		},



		//zobrazi filtre
		showFilters: function () {
			if (!this.showFilter) {
				this.showFilter = true;
			} else {
				this.showFilter = false;
			}
		},

		//vycisti text filter
		resetTextFilter: function () {
			this.selectedFilterText = '';
			this.onLoadPage();
		},

		// zobrazi napovedu
		showHelpbox: function () {
			if (!this.showedHelpbox) {
				this.showedHelpbox = true;
			} else {
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC


		//modal box gallery editacia
		loadModalFormPhotoEdit: function (recordID) {
			this.cSession();
			//console.log(recordID)
			this.selectedPhotoId = recordID;
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), { backdrop: 'static' })
			this.modalEdit.show();
		},

		//modal box gallery delete
		loadModalFormPhotoDelete: function (recordID) {
			this.cSession();
			//console.log(recordID)
			this.selectedPhotoId = recordID;
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), { backdrop: 'static' })
			this.modalDelete.show();
		},

		//modal box hromadne vymazanie
		loadModalFormPhotoDeleteBulk: function () {
			this.cSession();
			if (this.allSelectedItems.length > 0) {
				this.modalDeleteBulk = new bootstrap.Modal(document.getElementById(this.modalDeleteBulkId), { backdrop: 'static' })
				this.modalDeleteBulk.show();
			} else {
				this.toast.warning(this.$t('msgCore.selectRecords'));
			}
		},


		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedPhotoId = '';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage = selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage = 1;
			this.selectedRecords = selectedCount
			this.onLoadPage();
		},



		reloadAfterDeleteBulk() {
			//	console.log(e);
			this.onLoadPage();
			this.onResetSelected();
		},

		//otocenie obrazku o 90
		onRotateState: function (photoId) {
			this.cSession();
			this.isLoading = true
			rotatePhoto({ photoId }).then(response => {
				console.log(response)
				if (!response.statusText) {
					this.isLoading = false
					if (response.resCode == 1) {
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					} else if (response.resCode == 0) {
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					} else if (response.resCode == 2) {
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					} else if (response.resCode == 3) {
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				} else {
					this.isLoading = false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

		//zmena stavu
		onChangeState: function (e) {
			this.cSession();
			this.isLoading = true
			changeStatePhoto({ recordId: e.id, state: e.state }).then(response => {
				console.log(response)
				if (!response.statusText) {
					this.isLoading = false
					if (response.resCode == 1) {
						this.toast.success(this.$t('msgCore.dataWasSaved'));
						this.onLoadPage();
					} else if (response.resCode == 0) {
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					} else if (response.resCode == 2) {
						this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
					} else if (response.resCode == 3) {
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
				} else {
					this.isLoading = false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

		},

	},


	watch: {
		'auth.photosList': function () {
			this.onLoadPage();
		}
	},

	computed: {

	},

}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
		<div id="version" class="version">
			<p>{{ metaData.version }}</p>
		</div>

		<div v-if="metaData.modulAccess">

			<div class="row">
				<div class="col-12">

					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCore.Photos') }}</h5>
						</div>

						<div class="col-6 right">
							<button type="button" :disabled="!auth.photosDeleteBulk" :title="$t('msgCore.btnDelete')"
								class="btn btn-danger btn-sm" v-on:click="loadModalFormPhotoDeleteBulk()"><i
									class="smire-icon fas fa-trash-alt"></i> {{ $t('msgCore.btnDelete') }}</button>
						</div>
					</div>

					<!-- filters basic -->
					<div class="row">
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn"
								v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i>
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i>
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText'
								:placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn"
								v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
					</div>


					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-4">
							<select v-model='selectedGallery' class="form-control form-control-sm" v-on:change="onLoadPage()">
								<option value="">{{ $t('msgCore.selectGallery') }}</option>
								<option v-for="(option) in optionsGalleries" :value="option.value" :key="option">{{ option.title }}
								</option>
							</select>
						</div>
					</div>


				</div>
			</div>


			<!-- zakladny zoznam -->
			<div v-if="totalCount > 0">

				<div class="row">
					<div class="col-12">

						<div class="table-responsive">
							<table class="table table-hover table-sm">

								<thead>
									<tr>
										<th class="orderBy" v-on:click="orderByCol('a.id')"
											:class="{ active: isActive('a.id'), asc: isAsc('a.id'), desc: isDesc('a.id') }">ID</th>

										<th width="10" class="align-middle">
											<div class="form-check"><label class="form-check-label"><input v-model="checkAllItems"
														v-on:change="onCheckAllItems()" class="form-check-input" type="checkbox"><span
														class="form-check-sign"><span class="check"></span></span></label></div>
										</th>

										<th>
											{{ $t('msgCore.Action') }}
										</th>


										<th colspan="2">{{ $t('msgCore.State') }}</th>

										<th>{{ $t('msgCore.Preview') }}</th>

										<th class="orderBy" v-on:click="orderByCol('a.title')"
											:class="{ active: isActive('a.title'), asc: isAsc('a.title'), desc: isDesc('a.title') }">
											{{ $t('msgCore.Title') }}</th>

										<th>{{ $t('msgCore.Gallery') }}</th>

										<th>{{ $t('msgCore.Size') }}</th>

										<th class="orderBy" v-on:click="orderByCol('a.created')"
											:class="{ active: isActive('a.created'), asc: isAsc('a.created'), desc: isDesc('a.created') }">
											{{ $t('msgCore.Created') }}</th>

										<th>{{ $t('msgCore.Modified') }}</th>

										<th>{{ $t('msgCore.AccessLevel') }}</th>
									</tr>
								</thead>


								<tr v-for="(basicObj, index) in dataList" :key="basicObj">

									<td>{{ basicObj.id }}</td>

									<td class="align-middle">
										<div class="form-check">
											<label class="form-check-label">
												<input v-model.number='basicObj.selectedId' class="form-check-input" type="checkbox"
													v-on:change="onCheckItem(index, basicObj.id);">
												<span class="form-check-sign"><span class="check"></span></span>
											</label>
										</div>
									</td>

									<td>

										<button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.photosUnlock"
											v-on:click="onUnLock(basicObj.id)"
											v-bind:title="basicObj.checkedOutName + ', ' + basicObj.isCheckedOutDate" class="btn btn-sm"><i
												class="smire-icon fas fa-lock"></i></button>

										<div class="input-group">

											<div class="btn-group">
												<button type="button" :disabled="!auth.photosEdit"
													v-on:click="loadModalFormPhotoEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" id="myModalBtn"
													class="btn btn-secondary btn-sm"><i class="smire-icon fas fa-edit"></i></button>

												<button type="button" :disabled="!auth.photosDelete"
													v-on:click="loadModalFormPhotoDelete(basicObj.id)" :title="$t('msgCore.btnDelete')"
													id="myModalBtn" class="btn btn-danger btn-sm"><i
														class="smire-icon fas fa-trash-alt"></i></button>

											</div>

											<button type="button" :disabled="!auth.photosRotate" v-on:click="onRotateState(basicObj.id)"
												:title="$t('msgCore.btnRotate')" id="myModalBtn" class="btn btn-primary btn-sm"><i
													class="smire-icon fas fa-sync"></i></button>

										</div>
									</td>

									<td :title="$t('msgCore.' + basicObj.state_name)">
										<i class="fas fa-circle"
											:class="{ 'text-success': basicObj.state == 1, 'text-danger': basicObj.state == 2 }"></i>
									</td>

									<td>
										<CheckboxToggle :key="basicObj.id" :isDisabled="(!auth.photosChangeState)" :data="basicObj"
											@onClick="onChangeState"></CheckboxToggle>
									</td>

									<td>
										<!-- <a class="fancybox" data-fancybox="gallery" :href="basicObj.fotoDataOrigo"><img :src="basicObj.fotoData" style="height: 70px;"></a>-->

										<photo-provider>
											<photo-consumer :download-name="basicObj.title" :src="basicObj.fotoDataOrigo">
												<img :src="basicObj.fotoData" class="view-box" style="height: 70px; cursor:pointer;">
											</photo-consumer>
										</photo-provider>

									</td>

									<td>{{ basicObj.title }}</td>

									<td>{{ basicObj.gallery_name }}</td>

									<td>{{ basicObj.fileSize }}</td>

									<td>
										<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName"
											:color="basicObj.creatorColor" :date="basicObj.created" />
									</td>

									<td>
										<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName"
											:color="basicObj.editorColor" :date="basicObj.modified" />
									</td>



									<td>{{ basicObj.access_name }}</td>


								</tr>



							</table>
						</div>

					</div>
				</div>

				<div class="row row-pagination">
					<div class="col-6 col-md-3 col-lg-2">
						<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
					</div>

					<div class="col-6 col-md-3 col-lg-2 box-flex">
						<span>Počet: {{ totalCount }} <button v-if="allSelectedItems.length > 0" type="button" @click="onResetSelected()"
								class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i
									class="fas fa-times"></i></button></span>
					</div>

					<div class="col-12 col-md-6 col-lg-8">
					<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage"
						@onSelectPage="onChangePage"></MyPagination>
				</div>
			</div>


		</div>

		<div v-else class="row">
			<div class="col-12 mt-3">
				<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
			</div>
		</div>

	</div>

	<div v-else class="container-fluid">
		<div class="row">
			<div class="col-12 mt-3">
				<Alert type="warning" :label="$t('msgCore.accessDenied')" />
			</div>
		</div>
	</div>

	<PhotoEdit :auth="auth" :secData="secData" :photoId="String(selectedPhotoId)" @changeRecord="onChangeItem"
		:modalObject="modalEdit" :modalId="modalEditId"></PhotoEdit>
	<PhotoDelete :auth="auth" :secData="secData" :photoId="String(selectedPhotoId)" @changeRecord="onChangeItem"
		:modalObject="modalDelete" :modalId="modalDeleteId"></PhotoDelete>
	<PhotosDeleteBulk :auth="auth" :secData="secData" :photoIds="allSelectedItems"
		@changeAfterDeleteBulk="reloadAfterDeleteBulk" :modalObject="modalDeleteBulk" :modalId="modalDeleteBulkId">
	</PhotosDeleteBulk>


</div></template>


